import React, { Component } from 'react';
import { Table } from 'antd';
import utils from '../../common/utils'
const dateFormat = 'DD/MM/YYYY';

class WalletBalance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      walletBalance: [],
    };
  }
  
  componentDidMount() {
    this.props.onFetchWalletBalanceAction();
  }
  
  
  getColumns = (t) => {
    return [
      {
        align: 'center',
        title: 'Đồng',
        dataIndex: 'coin',
        key: 'coin',
      },
      {
        align: 'center',
        title: 'Số dư',
        dataIndex: 'balance',
        key: 'balance',
        render: utils.formatCurrency
      },
    ];
  };
  
  render() {
    console.log(this.props.walletBalance)
    const { walletBalance } = this.state;
    return (
      <div className="withdrawalHistory mr-medium ml-medium">
        <h3>Số dư ví</h3>
        <div className='mt-medium table-width-medium'>
          <Table dataSource={this.props.walletBalance}
                 columns={this.getColumns()}
                 bordered
                 pagination={{
                   hideOnSinglePage: true,
                 }}
          />
        </div>
      </div>
    );
  }
}

export default WalletBalance;
